import React from 'react';
import Badge from '@atlaskit/badge';
import { EnlargedSearchResultSectionContainer, SearchResultSectionTitleBadgeContainer, EnlargedSearchResultSectionHeading, EnlargedSearchResultsSectionTitle } from './search-result-section.styled';
export var EnlargedSearchResultSection = function EnlargedSearchResultSection(_ref) {
  var title = _ref.title,
    totalResults = _ref.totalResults,
    children = _ref.children;
  var hasTitle = Boolean(title);
  return /*#__PURE__*/React.createElement(EnlargedSearchResultSectionContainer, {
    "data-vc": "search-result-section-enlarged"
  }, hasTitle && /*#__PURE__*/React.createElement(EnlargedSearchResultSectionHeading, null, /*#__PURE__*/React.createElement(EnlargedSearchResultsSectionTitle, null, title, totalResults ? /*#__PURE__*/React.createElement(SearchResultSectionTitleBadgeContainer, null, /*#__PURE__*/React.createElement(Badge, {
    testId: "search-result-count-badge"
  }, totalResults)) : null)), children);
};